<template>
  <div class="order-container">
    <Header title="质检单查询结果"></Header>
    <div class="t-container main" >  
      <!-- <img :src="fileAddress" /> -->
      <!-- <iframe :src="fileAddress"></iframe> -->
      <p>{{ fileName }}</p>
      <!-- <img src="@/assets/imgs/zhijiandanxq.png" />
      <p>质检单</p>
      -->
    </div>
    <div class="content-pdf">
      <pdf 
        ref="pdf"
         v-for="i in numPages"
        :key="i"  
        :src="src" 
        :page="i"
        >
      </pdf>
    </div>
  </div>
</template>
<script>
import Header from '../../components/Header';
import pdf from 'vue-pdf'
export default {
  name: "QualityInspectionDetails",
  components: {
    pdf,
    Header
  },
  data() {
    return {
     numPages: '',
      str: '查看',
      show: true,
      fileName: '',
      fileAddress: '',
      form: {},
      src: ''
    };
  },
  computed: {
  },
  watch: { 
    
  },
  created() {
    this.fileName = this.$route.query.fileName;
    this.fileAddress = this.$route.query.fileAddress;
    let data = this.fileAddress.split('cn');
    this.fileAddress = data[1];
    console.log(222,this.fileAddress);
    let CMAP_URL = 'https://unpkg.com/pdfjs-dist@2.0.943/cmaps/';
    this.src = pdf.createLoadingTask({
      url: this.fileAddress,
      cMapUrl: CMAP_URL,
      cMapPacked: true,
    });
  },
  methods: {
    getNumPages() {
      let loadingTask = pdf.createLoadingTask(this.fileAddress)
      loadingTask.promise.then(pdf => {
        this.numPages = pdf.numPages
      }).catch(err => {
        console.error('pdf 加载失败', err);
      })
    }

  },
  mounted(){
    this.getNumPages()
  },
};
</script>
<style lang="stylus" scoped>
.order-container {
  .t-container {
    text-align: center;
    // padding-top: 40px;
    img {
      width: 100%;
    }
    p {
      font-size: 30px;
      margin-top: 30px;
    }
  }
}
.content-pdf{
  overflow:auto;
  flex:1;

}
</style>